import React, { useEffect, useState } from "react";
import { Badge, Card, Col } from "react-bootstrap";
import "./Cards.css";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import noimage from "./noimage.jpg";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { Box } from "@mui/material";
import 'react-circular-progressbar/dist/styles.css';
import { Icon } from "@iconify/react";

// import download from "./download.gif";
// console.log("USD\n" + usdExchange + "\nARS\n" + arsExchange + "\nAUD\n" + audExchange + "\nBRL\n" + brlExchange + "\nCAD\n" + cadExchange + "\nCLP\n" + clpExchange + "\nCOP\n" + copExchange
//   + "\nMXN\n" + mxnExchange + "\nPEN\n" + penExchange + "\nPLN\n" + plnExchange + "\nRUB\n" + rubExchange + "\nZAR\n" + zarExchange);

const SALE_STATUS_URLS = [
  "https://raw.githubusercontent.com/maysaleba/switch-games/main/output/current_sale_status.json",
  "https://raw.githubusercontent.com/maysaleba/playstation-games/main/playstation_current_sale_status.json",
];
let saleStatusPromise = null;
export const loadSaleStatus = () => {
  if (!saleStatusPromise) {
    saleStatusPromise = Promise.all(
      SALE_STATUS_URLS.map((url) =>
        fetch(url)
          .then((r) => (r.ok ? r.json() : {}))
          .catch(() => ({}))
      )
    ).then((parts) => Object.assign({}, ...parts));
  }
  return saleStatusPromise;
};

const parseTurkeyPrice = (value) => {
  if (value === undefined || value === null || value === "" || value === "null") return "";
  return Number(String(value).replace(".", "")) / 100;
};

const LOW_TAGS = {
  new_low: { label: "New Low", bg: "", className: "low-tag-new" },
  matches_low: { label: "Matches Low", bg: "", className: "low-tag-subtle" },
};

const Cards = ({
  datam = {},
  Title,
  Image,
  Score,
  SaleEnds,
  Genre,
  Slug,
  SalePrice,
  SalePricePHP,
  CheapestRegion,
  Discount,
  URL,
  Platform,
  PlusPrice,
  Price,
  Currency,
  idPrice,
  idSalePrice,
  inPrice,
  inSalePrice,
  sgPrice,
  sgSalePrice,
  trPrice,
  trSalePrice,
  usPrice,
  usSalePrice,
  hkPrice,
  hkSalePrice,
  CanadaPrice,
  PeruPrice,
  ArgentinaPrice,
  AustraliaPrice,
  ColombiaPrice,
  SouthafricaPrice,
  BrazilPrice,
  NorwayPrice,
  PolandPrice,
  NewZealandPrice,
  KoreaPrice,
  HongKongPrice,
  JapanPrice,
  MexicoPrice,
  SingaporePrice,
  ThailandPrice,
  MalaysiaPrice,
  SwitzerlandPrice,
  ESRBRating,
  IsPS4,
  IsPS5
}) => {


    var usdExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.USD);
    var arsExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.ARS);
    var audExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.AUD);
    var brlExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.BRL);
    var cadExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.CAD);
    var chfExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.CHF);
    var nzdExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.NZD);
    var copExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.COP);
    var mxnExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.MXN);
    var penExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.PEN);
    var plnExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.PLN);
    var nokExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.NOK);
    var zarExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.ZAR);
    var sgdExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.SGD);
    var hkdExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.HKD);
    var trdExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.TRY);
    var jpyExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.JPY);
    var krwExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.KRW);
    var myrExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.MYR);
    var thbExchange = JSON.stringify(datam.PHP) / JSON.stringify(datam.THB);
  

  // Is rate data loaded?
  const ratesReady = !!datam?.PHP;

const phpCeil = (value, placeholder = "₱--") =>
  Number.isFinite(Number(value))
    ? "₱" + Math.ceil(Number(value))
    : placeholder;

const safePhp = (amt, rate, placeholder = "₱--") =>
  phpCeil(Number(amt) * Number(rate), placeholder);



  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
 

function DaysLeft(props) {
  if (!props.isExpired) return null;

  const now = new Date();
  const todayDateOnly = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  const saleDateOnly = String(props.isExpired).slice(0, 10);

  if (!/^\d{4}-\d{2}-\d{2}$/.test(saleDateOnly)) return null;

  if (saleDateOnly >= todayDateOnly) {
    // integer day difference using local date parts to avoid UTC offset drift
    const [sy, sm, sd] = saleDateOnly.split("-").map(Number);
    const [ty, tm, td] = todayDateOnly.split("-").map(Number);
    const saleMs = new Date(sy, sm - 1, sd).getTime();
    const todayMs = new Date(ty, tm - 1, td).getTime();
    const diffDays = Math.round((saleMs - todayMs) / oneDay);

    return (
      <Badge bg="warning" text="dark">
        {diffDays} days left
      </Badge>
    );
  }

  return (
    <Badge bg="warning" text="dark">
      0 days left
    </Badge>
  );
}

  function OpenScore(score) {
    const hasScore = score.hasScore;
    if (hasScore === "-1" || hasScore === "" || hasScore === "0") {
      return null;
    }
    return (
<>


      <div className="d-flex justify-content-left float-end opencritic-container2">
    
        <CircularProgressbar
        className="score-text"
        value={Score}
        text={Score}
        background
        backgroundPadding={6}
        styles={buildStyles({
          backgroundColor: "rgba(0%, 0%, 0%, 0.5)",
          textColor: "#fff",
          pathColor: Score <= 49 ? "#80b06a" : (Score <= 74 ? "#ffcc33" : "#fc430a"),
          textSize: "35px",
          trailColor: Score <= 49 ? "#80b06a60" : (Score <= 74 ? "#ffcc3360" : "#fc430a60"),
        })}
      />
      </div>


</>
    );
  }

  function PercentOff(props) {
    return (
      <Badge pill bg="danger">
        {"-" + Discount}
      </Badge>
    );
  }

  function parseTurkeyPrice(value) {
  if (value === undefined || value === null || value === "" || value === "null") return null;
  return Number(String(value).replace(".", "")) / 100;
}

function getPsCheapest() {
  if (!datam?.PHP) return null;

  const rows = [
    { code: "ID", className: "idregion-logo", sale: idSalePrice || idPrice, original: idPrice, ccy: "IDR" },
    { code: "IN", className: "inregion-logo", sale: inSalePrice || inPrice, original: inPrice, ccy: "INR" },
    { code: "SG", className: "sgregion-logo", sale: sgSalePrice || sgPrice, original: sgPrice, ccy: "SGD" },
    {
      code: "TR",
      className: "trregion-logo",
      sale: parseTurkeyPrice(trSalePrice || trPrice),
      original: parseTurkeyPrice(trPrice),
      ccy: "TRY",
    },
    { code: "US", className: "usregion-logo", sale: usSalePrice || usPrice, original: usPrice, ccy: "USD" },
    { code: "HK", className: "hkregion-logo", sale: hkSalePrice || hkPrice, original: hkPrice, ccy: "HKD",},
  ];

  return rows
    .map((r) => {
      const rate = Number(datam.PHP) / Number(datam[r.ccy]);
      const salePhp = Number(r.sale) * rate;
      const originalPhp = Number(r.original) * rate;

      return {
        ...r,
        salePhp,
        originalPhp,
      };
    })
    .filter((r) => Number.isFinite(r.salePhp) && r.salePhp > 0)
    .sort((a, b) => a.salePhp - b.salePhp)[0];
}

  function PesoPrice(props) {
    if (props.psorsw === "Nintendo Switch" || props.psorsw === "Nintendo Switch 2") {
      var testBoolean;
      // console.log(props);
      if (ArgentinaPrice != 0) {
        if ((ArgentinaPrice * arsExchange) / usdExchange <= 10) {
          // console.log((matchGames[0].ArgentinaPrice * arsExchange) / usdExchange)
          //console.log("less than 10")
          testBoolean = true;
        } else {
          //console.log((matchGames[0].ArgentinaPrice * arsExchange) / usdExchange)
          //more than 10
          testBoolean = false;
        }
      }
      // var argentinaTax = Math.round(
      //   (testBoolean
      //     ? ArgentinaPrice * arsExchange * 1.59
      //     : ArgentinaPrice * arsExchange * 1.59) -
      //     ArgentinaPrice * arsExchange
      // );

      // var argentinaTaxAR = Math.round(
      //   (testBoolean
      //     ? ArgentinaPrice * 1.59
      //     : ArgentinaPrice * 1.59) -
      //     ArgentinaPrice
      // );

      var regionalityTax = ArgentinaPrice * arsExchange * 1.21 * ((1500 - (12100 * arsExchange))/ (12100 * arsExchange))

      var argentinaTax = Math.round(
        (testBoolean
          ? ArgentinaPrice * arsExchange * 1.21
          : ArgentinaPrice * arsExchange * 1.21) -
          ArgentinaPrice * arsExchange
      );


      var pricesobj = {
        Canada: CanadaPrice * cadExchange,
        Switzerland: SwitzerlandPrice * chfExchange,
        Peru: PeruPrice * penExchange,
        Argentina: argentinaTax + regionalityTax + ArgentinaPrice * arsExchange,
        //Argentina: ArgentinaPrice * arsExchange * 1.64,
        Australia: AustraliaPrice * audExchange,
        Colombia: ColombiaPrice * copExchange,
        Southafrica: SouthafricaPrice * zarExchange,
        Brazil: BrazilPrice * brlExchange,
        Norway: NorwayPrice * nokExchange,
        Poland: PolandPrice * plnExchange,
        NewZealand: NewZealandPrice * nzdExchange,
        Mexico: MexicoPrice * mxnExchange,
        US: SalePrice * usdExchange,
        HongKong: HongKongPrice * hkdExchange,
        Japan: JapanPrice * jpyExchange,
        Korea: KoreaPrice * krwExchange,
        Singapore: SingaporePrice * sgdExchange,
        Malaysia: MalaysiaPrice * myrExchange,
        Thailand: ThailandPrice * thbExchange

      };

      Object.entries(pricesobj).forEach(([k, v]) => {
        if (v === 0) delete pricesobj[k];
      });

      // console.log(pricesobj)

      //                 const entries = Object.entries(pricesobj).sort(([, a], [, b]) => a - b);

      // var rank1 = entries[0][0] + ": " + entries[0][1]
      // var rank2 = entries[1][0] + ": " + entries[1][1]
      // var rank3 = entries[2][0] + ": " + entries[2][1]

      //  console.log(rank1 + "\n" + rank2 + "\n" + rank3);

      var smallest = "";
      var smallestprice;
      for (var key in pricesobj) {
        if (smallest !== "" && pricesobj[key] < pricesobj[smallest]) {
          smallest = key;
          smallestprice = pricesobj[key];
        } else if (smallest === "") {
          smallest = key;
          smallestprice = pricesobj[key];
        }
      }
      // console.log("smallest---", smallest + "\n" + smallestprice);

function SmallestFlag() {
  const regionClassMap = {
    US: "usregion-logo",
    Argentina: "arregion-logo",
    Australia: "auregion-logo",
    Brazil: "brregion-logo",
    Canada: "caregion-logo",
    Switzerland: "chregion-logo",
    NewZealand: "nzregion-logo",
    Colombia: "coregion-logo",
    Mexico: "mxregion-logo",
    Peru: "peregion-logo",
    Poland: "plregion-logo",
    Norway: "noregion-logo",
    Southafrica: "zaregion-logo",
    HongKong: "hkregion-logo",
    Korea: "krregion-logo",
    Japan: "jpregion-logo",
    Singapore: 'sgregion-logo',
    Malaysia: 'myregion-logo',
    Thailand: 'thregion-logo'
  };

if (!ratesReady || !smallest) {
  return (
    <span className="price-bold d-inline-flex align-items-center">
      <Icon
        icon="mdi:earth"
        width="15"
        style={{ marginRight: "5px" }}
      />
      {safePhp(smallestprice, 1)}
    </span>
  );
}

  const className = regionClassMap[smallest];
  if (!className) return null;

  return (
    <span className={`${className} price-bold`}>
      {safePhp(smallestprice, 1)}
    </span>
  );
}




      return (
        <>
          <SmallestFlag />
        </>
      );
    }
if (props.psorsw === "Playstation") {
  const cheapest = getPsCheapest();

  return (
<span className={`${cheapest?.className || "psregion-logo"} price-bold`}>
      {phpCeil(cheapest?.salePhp)}
    </span>
  );
}


    if (props.psorsw === "ogprice") {
      if (props.platform === "Playstation") {
        const cheapest = getPsCheapest();

        return (
          <span className="price-light">
            {cheapest && Number.isFinite(cheapest.originalPhp)
              ? phpCeil(cheapest.originalPhp)
              : "₱--"}
          </span>
        );
      } else {
        return (
          <span className="price-light">
            {safePhp(props.saleprice, regularPriceRate(Currency))}
          </span>
        );
      }
    }
  }

  const currencyRates = {
    USD: usdExchange,
    ARS: arsExchange,
    AUD: audExchange,
    BRL: brlExchange,
    CAD: cadExchange,
    NZD: nzdExchange,
    COP: copExchange,
    MXN: mxnExchange,
    PEN: penExchange,
    PLN: plnExchange,
    NOK: nokExchange,
    ZAR: zarExchange,
    SGD: sgdExchange,
    HKD: hkdExchange,
    TRY: trdExchange,
    JPY: jpyExchange,
    KRW: krwExchange,
    MYR: myrExchange,
    THB: thbExchange,
    PHP: 1,
  };

  function regularPriceRate(currencyCode) {
    const normalized = String(currencyCode || "USD").trim().toUpperCase();
    return currencyRates[normalized] ?? usdExchange;
  }

  function PesoPlusPrice(props) {
    if (props.psorsw === "Nintendo Switch" || props.psorsw === "Nintendo Switch 2") {
      return null;
    }
    if (props.psorsw === "Playstation") {
      if (props.esrbrating === "SGD") {
                    if (PlusPrice === 0) {
        return (
          <span className="psplusbadge" style={{ fontWeight: "bold" }}>
            FREE
          </span>
        );
      } else if (PlusPrice === 999999) {
        return (
          <span className="psplusbadge" style={{ fontWeight: "bold" }}>
            TRIAL
          </span>
        );
}
else if (PlusPrice === 202020) {
        return (
          <span className="eabadge" style={{ fontWeight: "bold" }}>
            FREE
          </span>
        );
}
      else {
        return (
          <span className="psplusbadge" style={{ fontWeight: "bold" }}>
            {safePhp(PlusPrice, sgdExchange)}
          </span>
        );
      }

      } else       if (props.esrbrating === "HKD") {
                    if (PlusPrice === 0) {
        return (
          <span className="psplusbadge" style={{ fontWeight: "bold" }}>
            FREE
          </span>
        );
      } else if (PlusPrice === 999999) {
        return (
          <span className="psplusbadge" style={{ fontWeight: "bold" }}>
            TRIAL
          </span>
        );
}
else if (PlusPrice === 202020) {
        return (
          <span className="eabadge" style={{ fontWeight: "bold" }}>
            FREE
          </span>
        );
}
      else {
        return (
          <span className="psplusbadge" style={{ fontWeight: "bold" }}>
            {safePhp(PlusPrice, hkdExchange)}
          </span>
        );
      }

      } else       if (props.esrbrating === "TRD") {
                    if (PlusPrice === 0) {
                      return null;
        // return (
        //   <span className="psplusbadge" style={{ fontWeight: "bold" }}>
        //     FREE
        //   </span>
        // );
      } else if (PlusPrice === 999999) {
        return (
          <span className="psplusbadge" style={{ fontWeight: "bold" }}>
            TRIAL
          </span>
        );
}
else if (PlusPrice === 202020) {
        return (
          <span className="eabadge" style={{ fontWeight: "bold" }}>
            FREE
          </span>
        );
}
      else {
        return null;
        // return (
        //   <span className="psplusbadge" style={{ fontWeight: "bold" }}>
        //     {"₱" + Math.round(PlusPrice * trdExchange)}
        //   </span>
        // );
      }

      } 

       else {
              if (PlusPrice === 0) {
        return (
          <span className="psplusbadge" style={{ fontWeight: "bold" }}>
            FREE
          </span>
        );
      } else if (PlusPrice === 999999) {
        return (
          <span className="psplusbadge" style={{ fontWeight: "bold" }}>
            TRIAL
          </span>
        );
}
else if (PlusPrice === 202020) {
        return (
          <span className="eabadge" style={{ fontWeight: "bold" }}>
            FREE
          </span>
        );
}
      else {
        return (
          <span className="psplusbadge" style={{ fontWeight: "bold" }}>
            {safePhp(PlusPrice, usdExchange)}
          </span>
        );
      }
      }
    }
  }

  function PlatformBadge(props) {
    const platform = props.hasBadge;
    if (platform === "Nintendo Switch" || platform === "Nintendo Switch 2") {

      if (props.esrbrating === "Individual" || props.esrbrating === "Bundle" || props.esrbrating === "DLC") {
      return (
        <> 
        <span className="d-flex justify-content float-start opencritic-container2 img-responsive nbadges nintendo"></span>
        <div className="d-flex justify-content float-start opencritic-container2">
<Box className="deal-type-badge deal-type-dlc">
  DLC
</Box>
      </div>
        </>
      );


      } else if (props.esrbrating === "ROM Bundle") {
      return (
        <>
        <span className="d-flex justify-content float-start opencritic-container2 img-responsive nbadges nintendo"></span>
        <div className="d-flex justify-content float-start opencritic-container2">
<Box className="deal-type-badge deal-type-bundle">
  BUNDLE
</Box>
      </div>
      </>
      );
      }
      else {
        return (
        <span className="d-flex justify-content float-start opencritic-container2 img-responsive nbadges nintendo"></span>
        )
      }
    }
    if (platform === "Playstation") {
        return (
        <span className="img-responsive pbadges playstation1"></span>
        )

    }
  }


  const [saleStatus, setSaleStatus] = useState(null);
  useEffect(() => {
    let alive = true;
    loadSaleStatus().then((d) => alive && setSaleStatus(d));
    return () => {
      alive = false;
    };
  }, []);

  // Country code of the cheapest region (in PHP), used to look up the status
  function cheapestCountry() {
    if (!datam || !datam.PHP) return null;
    const toPHP = (amt, ccy) =>
      +amt * (Number(datam.PHP) / Number(datam[ccy] || 1));
    const candidates =
      Platform === "Playstation"
        ? {
            ID: [idSalePrice || idPrice, "IDR"],
            IN: [inSalePrice || inPrice, "INR"],
            SG: [sgSalePrice || sgPrice, "SGD"],
            TR: [parseTurkeyPrice(trSalePrice || trPrice), "TRY"],
            US: [usSalePrice || usPrice, "USD"],
            HK: [hkSalePrice || hkPrice, "HKD"],
          }
        : {
      US: [SalePrice, "USD"],
      CA: [CanadaPrice, "CAD"],
      CH: [SwitzerlandPrice, "CHF"],
      PE: [PeruPrice, "PEN"],
      AU: [AustraliaPrice, "AUD"],
      CO: [ColombiaPrice, "COP"],
      ZA: [SouthafricaPrice, "ZAR"],
      BR: [BrazilPrice, "BRL"],
      NO: [NorwayPrice, "NOK"],
      PL: [PolandPrice, "PLN"],
      NZ: [NewZealandPrice, "NZD"],
      MX: [MexicoPrice, "MXN"],
      HK: [HongKongPrice, "HKD"],
      KR: [KoreaPrice, "KRW"],
      JP: [JapanPrice, "JPY"],
      SG: [SingaporePrice, "SGD"],
      MY: [MalaysiaPrice, "MYR"],
      TH: [ThailandPrice, "THB"],
    };
    let best = null;
    let bestPrice = Infinity;
    Object.entries(candidates).forEach(([code, [amt, ccy]]) => {
      const php = toPHP(amt, ccy);
      if (Number.isFinite(php) && php > 0 && php < bestPrice) {
        best = code;
        bestPrice = php;
      }
    });
    const ars = +ArgentinaPrice;
    if (Platform !== "Playstation" && Number.isFinite(ars) && ars > 0 && datam.ARS) {
      const phpPerARS = Number(datam.PHP) / Number(datam.ARS);
      const base = ars * phpPerARS;
      const tax = base * 1.21 * ((1500 - 12100 * phpPerARS) / (12100 * phpPerARS));
      const total = base * 1.21 + tax;
      if (total > 0 && total < bestPrice) best = "AR";
    }
    return best;
  }

  const lowStatus =
    saleStatus && Slug && saleStatus[Slug]
      ? saleStatus[Slug][cheapestCountry()]
      : null;
  const lowTag = LOW_TAGS[lowStatus];

function PlatformOverlay({ title, slug, isps4, isps5 }) {
  if (!slug) {
    console.error("Undefined slug found in record:", title);
    return null;
  }

  if (slug.includes("-switch-2")) {
    return <div className="additional-overlay">NSW2</div>;
  }

  if (slug.includes("-switch")) {
    return <div className="additional-overlay">NSW</div>;
  }

  if (isps4 === 1 && isps5 === 1) {
    return (
      <>
        <div className="additional-overlay">PS5</div>
        <div className="additional-overlay-right">PS4</div>
      </>
    );
  }

  if (isps4 === 1) {
    return <div className="additional-overlay">PS4</div>;
  }

  if (isps5 === 1) {
    return <div className="additional-overlay">PS5</div>;
  }

  return <div className="additional-overlay">NONE</div>;
}




  return (
    <Col>
<Link to={`/games/${Slug}`} className="linkto card-link">
<Card className={`border-0 ${Slug.includes("switch-2") ? "switch2-card" : ""}`}>

    {Slug.includes("switch-2") && (
       <div className="platform-top-badge-outside">
  <svg
    width="34"
    height="24"
    viewBox="0 0 30 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    alt=""
    data-testid="NintendoSwitch2LogoOnlyIcon"
    size="34"
    color="currentColor"
  >
    <path
      d="M9.66879 4.54634H7.24725C5.67883 4.54634 4.40649 5.81867 4.40649 7.3871V12.7842C4.40649 14.3527 5.67883 15.625 7.24725 15.625H9.66879C9.71276 15.625 9.75087 15.5898 9.75087 15.5429V4.62842C9.75087 4.58445 9.71569 4.54634 9.66879 4.54634ZM8.85672 14.7309H7.24725C6.72835 14.7309 6.23877 14.5286 5.86938 14.1621C5.50293 13.7957 5.29771 13.3061 5.29771 12.7842V7.3871C5.29771 6.86526 5.5 6.37861 5.86645 6.00923C6.23291 5.64277 6.72249 5.43756 7.24432 5.43756H8.85379V14.7279L8.85672 14.7309ZM7.17396 6.83008C7.74856 6.83008 8.21469 7.29621 8.21469 7.87082C8.21469 8.44542 7.74856 8.91155 7.17396 8.91155C6.59936 8.91155 6.13323 8.44542 6.13323 7.87082C6.13323 7.29621 6.59936 6.83008 7.17396 6.83008ZM12.6444 4.54634H10.9294C10.8883 4.54634 10.8561 4.57859 10.8561 4.61963V15.5429C10.8561 15.5869 10.8913 15.625 10.9382 15.625H12.6415C14.2099 15.625 15.4822 14.3527 15.4822 12.7842V7.3871C15.4822 5.81867 14.2099 4.54634 12.6415 4.54634H12.6444ZM13.049 11.7582C12.4304 11.7582 11.9291 11.2569 11.9291 10.6383C11.9291 10.0197 12.4304 9.5184 13.049 9.5184C13.6675 9.5184 14.1689 10.0197 14.1689 10.6383C14.1689 11.2569 13.6675 11.7582 13.049 11.7582ZM17.3497 15.625V13.7224C17.5461 13.5611 18.2907 12.922 19.0764 12.2448C19.7829 11.635 20.4895 11.0253 21.2106 10.4331C21.753 9.98746 22.7849 9.1666 22.8172 8.36333C22.8553 7.41934 22.1869 6.80663 21.1843 6.80663C20.5891 6.80663 19.8885 7.13791 19.4634 7.4985C19.0383 7.85909 18.4959 8.32522 18.4959 8.32522L16.9275 6.62487C18.2585 5.13267 19.6891 4.3763 21.1813 4.3763C24.3592 4.29715 26.7573 7.8415 24.3387 10.6178C23.4621 11.5852 22.4654 12.4911 21.4422 13.2943H25.5934V15.625H17.3467H17.3497Z"
      fill="currentColor"
    />
  </svg>
</div>

    )}
 <div className={`card-img-wrapper ${Slug.includes("switch-2") ? "no-border-radius" : ""}`}>
    {/* Blurred background */}
    <img
      src={Image}
      alt=""
      className="card-img-background"
      onError={(event) => {
        event.target.src = noimage;
        event.onerror = null;
      }}
    />

    {/* Foreground image */}
    <LazyLoadImage
      effect="opacity"
      key={Image}
      className="card-img-foreground"
      src={Image}
      onError={(event) => {
        event.target.src = noimage;
        event.onerror = null;
      }}
      visibleByDefault={Image}
    />

    <Card.ImgOverlay>
      <PlatformBadge hasBadge={Platform} esrbrating={ESRBRating} slug={Slug}/>
      <OpenScore hasScore={Score} />
    </Card.ImgOverlay>

    <PlatformOverlay slug={Slug} isps4={IsPS4} isps5={IsPS5} title={Title}/>
  </div>

    <Card.Body>
        <Card.Title className="card-title">{Title.replace(/ *\([^)]*\) */g, "").replaceAll("Ã¢„Â™","™").replace("â„¢","™")}</Card.Title>
        <Card.Text className="card-text">
            <PercentOff />{" "}
            <strike>
                <PesoPrice psorsw="ogprice" saleprice={Price} esrbrating={ESRBRating} platform={Platform}/>
            </strike>{" "}
            <PesoPrice
                psorsw={Platform}
                esrbrating={ESRBRating}
                saleprice={SalePrice}
                canadaprice={CanadaPrice}
                peruprice={PeruPrice}
                argentinaprice={ArgentinaPrice}
                australiaprice={AustraliaPrice}
                colombiaprice={ColombiaPrice}
                southafricaprice={SouthafricaPrice}
                brazilprice={BrazilPrice}
                norwayprice={NorwayPrice}
                polandprice={PolandPrice}
                newzealandprice={NewZealandPrice}
                mexicoprice={MexicoPrice}
                hongkongprice={HongKongPrice}
                koreaprice={KoreaPrice}
                japanprice={JapanPrice}
                singaporeprice={SingaporePrice}
                malaysiaprice={MalaysiaPrice}
                thailandprice={ThailandPrice}
            />{" "}
            <PesoPlusPrice psorsw={Platform} pesoplus={PlusPrice}  esrbrating={ESRBRating}/>{" "}
            <DaysLeft isExpired={SaleEnds} platform={Platform} />{" "}
            {lowTag && <Badge bg={lowTag.bg} className={lowTag.className}>{lowTag.label}</Badge>}
        </Card.Text>
    </Card.Body>
</Card>
      </Link>
    </Col>
  );
};

export default Cards;
